import { render, staticRenderFns } from "./c-chart-budget-view@.vue?vue&type=template&id=1081a480&"
import script from "./c-chart-budget-view@.vue?vue&type=script&lang=ts&"
export * from "./c-chart-budget-view@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports